import { toast } from "sonner";
import { translate } from "@/i18n/translate";

/** Copies a value and confirms it with a toast ("Pizza ID copied"); `what` is already translated. */
export const copyToClipboard = (value: string, what: string) => {
  navigator.clipboard
    ?.writeText(value)
    .then(() => toast.success(translate("common.copied", { what })))
    .catch(() => toast.error(translate("common.copyFailed", { what })));
};
